import * as React from 'react';
import ProductAvailabilityInfo from 'PyzShopUi/components/molecules/product-availability-info/product-availability-info';
import ArticleTabVariantAddToCart from '../article-tab-variant-add-to-cart/article-tab-variant-add-to-cart';
import ArticleTabVariantImportantNotes from '../article-tab-variant-important-notes/article-tab-variant-important-notes';
import FormattedCurrency from 'PyzShopUi/scripts/react/common/components/FormattedCurrency';
import { FootnoteManager } from 'PyzShopUi/scripts/modules/footnote';
import FootnoteService from 'PyzShopUi/scripts/shop-ui/services/FootnoteService';
import { EFootnoteNamespace } from 'PyzShopUi/scripts/shop-ui/constants';
import {FOOTNOTE_NAME_UVP_SET_PRICE_NOT_EQUAL_TO_INDIVIDUAL_PRICE} from 'PyzShopUi/scripts/footnote/constants';
import {
    updateRecommendationApiUrl
} from 'PyzShopUi/scripts/product-detail-page/includes/productDetailPageUrlParamHelper';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import Loading from 'PyzShopUi/scripts/react/common/components/Loading';
import { FILTER_LABEL_MAPPING, FilterNames } from 'PyzShopUi/scripts/catalog-page/constants';
import Marker from 'PyzShopUi/scripts/shop-ui/components/Marker';
import ProductVariantDataHandler from 'PyzShopUi/scripts/product-detail-page/includes/productVariantData';
import {createRoot} from 'react-dom/client';
import {flushSync} from 'react-dom';
import {AVAILABILITY_CONSTANTS} from 'PyzShopUi/scripts/constants/availability';

const FOOTNOTE_SET_NUMBER = 5;
const PRICE_DIVIDE_NUMBER = 100;

const articleTabVariantList = props => {
    const {
        isBikeSpecificArticle,
        showColor,
        showSize,
        csrfToken,
        addToCartApiUrl,
        recommendationApiUrl,
        productVariants,
    } = props;

    const footnoteServiceInstance = React.useRef<FootnoteService>(FootnoteService.getInstance());
    const {translate} = useTranslationHook();

    const getProductAvailabilityContainer = data => {
        const availabilityState = (data?.product_concrete_availability?.availability_state) ?? AVAILABILITY_CONSTANTS.NOT_AVAILABLE;

        return (
            <div className="product-availability-container">
                <ProductAvailabilityInfo
                    sku={data.sku}
                    availabilityState={availabilityState}
                    deliveryWeek={data?.product_concrete_availability?.delivery_week}
                />
            </div>
        );
    };
    const updateProductInformation = data => {
        const articalVariants = document.querySelector(`.article-all-variants tr[data-concrete-id="${data.id_product_concrete}"]`);
        const availabilityContainer = articalVariants.querySelector(`.article-variant-availability`);
        const existingAvailabilityContainer = availabilityContainer.querySelector('.product-availability-button');
        if (existingAvailabilityContainer) {
            existingAvailabilityContainer.remove();
        }
        const productAvailabilityContainer: JSX.Element = getProductAvailabilityContainer(data);
        const availabilityContainerDiv = document.createElement('div');
        const root = createRoot(availabilityContainerDiv);
        flushSync(() => {
            root.render(productAvailabilityContainer);
        });
        availabilityContainer.append(availabilityContainerDiv);

    };
    const createFetchProductAvailabilityHandler =
        (apiUrl: string): (concreteId: number) => void => {
            return (concreteId: number): void => {
                const productVariantData = ProductVariantDataHandler.init();
                const sku = productVariantData[concreteId]?.sku;

                if (typeof sku !== 'undefined') {
                    const apiUrlObject = new URL(apiUrl, window.location.origin);
                    const searchParams = new URLSearchParams();
                    searchParams.set('sku', sku);
                    apiUrlObject.search = searchParams.toString();

                    fetch(apiUrlObject.toString())
                        // tslint:disable-next-line:no-any
                        .then((response: Response): Promise<any> => response.json())
                        .then(data => updateProductInformation(data));
                }
            };
    };
    const checkProductAvailability = event => {
        const articleMainInfoElement: HTMLElement = document.querySelector('.article-main-info');
        const productFilterElement: HTMLElement = articleMainInfoElement.querySelector('div [data-spryker-product-filter="true"]');
        if (!productFilterElement) {
            return;
        }
        const apiUrl: string = productFilterElement.dataset.apiUrl;
        const fetchProductFunction = createFetchProductAvailabilityHandler(apiUrl);
        fetchProductFunction(event.currentTarget.getAttribute('data-product-concrete-id'));
    };

    return (
        <React.Fragment>
            {productVariants.map(variant => {
                const variantUrl = `${window.location.pathname}?filter_article_number=${variant.sku}`;
                const isSet = variant.catalog_origin && variant.catalog_origin === FOOTNOTE_SET_NUMBER;
                const isBatteryDeposit = variant.battery_deposit && variant.battery_deposit_price !== null;

                const seoTitleSecondary = (variant?.seo_title_secondary !== undefined && variant?.seo_title_secondary !== null) ? ` ${variant.seo_title_secondary}` : '';
                const variantTitle = `${seoTitleSecondary}`;
                const name = (variant?.brand_name !== undefined && variant?.brand_name !== null) ? `${variant.brand_name}  ${variant.name}` : `${variant.name}`;

                let variantName = `${name}`;
                if (variantTitle.trim().length !== 0) {
                    variantName = `${name} ${variantTitle && ` - ${variantTitle}`}`;
                }

                if (isSet) {
                    footnoteServiceInstance.current.addFootnote(FOOTNOTE_NAME_UVP_SET_PRICE_NOT_EQUAL_TO_INDIVIDUAL_PRICE, EFootnoteNamespace.PDP_ALL_VARIANTS_ARTICLE_PRICE);
                }

                if (isBatteryDeposit) {
                    footnoteServiceInstance.current.addFootnote(FootnoteManager.deposit, EFootnoteNamespace.PDP_ALL_VARIANTS_ARTICLE_PRICE);
                }

                const newRecommendationApiUrl = updateRecommendationApiUrl(
                    recommendationApiUrl,
                    variant.rich_relevance_full_id
                );

                return (
                    <tr data-concrete-id={variant.id_product_concrete} key={variant.id_product_concrete}>
                        <td className="row-cell-headline" itemProp="optionName"
                            data-variant-option-name={variant.option_name}>
                            <span className="variant-name" itemProp="name" data-variant-name={variant.name}>
                                {variantName} {
                                variant.is_outlet &&
                                <Marker
                                    label={translate(FILTER_LABEL_MAPPING[FilterNames.OUTLET], {ns: 'article-list-filter'}).toLocaleUpperCase()}
                                    color={`orange`}
                                    labelFor={variant.name}
                                />
                            }
                            </span>
                            <link itemProp="url" href={variantUrl}/>
                            <ArticleTabVariantImportantNotes
                                notes={variant.important_notes.filter(note => note.text !== null)}
                            />
                        </td>
                        {!isBikeSpecificArticle && showColor && <td className="row-small-half">
                            <span className="hide-for-large row-headline">{translate('Colour', {ns: 'article-detail'})}: </span>
                            {variant.colors.map(color => translate(color, {ns: 'article-list-filter'})).join(', ')}
                        </td>}
                        {!isBikeSpecificArticle && showSize && <td className="row-small-half">
                            <span className="hide-for-large row-headline">{translate('Size', {ns: 'article-detail'})}: </span>
                            {variant.size}
                        </td>}
                        <td className="row-small-half" data-sku={variant.sku}>
                            <span className="hide-for-large row-headline">{translate('Art. No.', {ns: 'article-detail'})}: </span>
                            {variant.sku}
                        </td>
                        <td className="row-small-half article-variant-availability"
                            data-availability-state={variant.product_concrete_availability.availability_state}
                            data-delivery-week={variant.product_concrete_availability.delivery_week}>
                            <span className="hide-for-large row-headline">{translate('Availability', {ns: 'article-detail'})}: </span>
                            <React.Suspense fallback={<Loading/>}>
                                <ProductAvailabilityInfo
                                    sku={variant.sku}
                                    availabilityState={variant.product_concrete_availability.availability_state}
                                    deliveryWeek={variant.product_concrete_availability.delivery_week}
                                />
                            </React.Suspense>
                        </td>
                        <td className="row-small-half price">
                            <span className="hide-for-large row-headline">{translate('Price', {ns: 'article-detail'})}</span>
                            <span itemProp="offers" itemScope itemType="https://schema.org/Offer">
                                <meta itemProp="priceCurrency" content={variant.currency?.code}/>
                                <span itemProp="price" content={(variant.price / PRICE_DIVIDE_NUMBER).toString()}>
                                    <FormattedCurrency price={variant.price / PRICE_DIVIDE_NUMBER} currency={variant.currency?.code}/>
                                </span>
                            </span>

                            {isSet ?
                                <sup>
                                    {footnoteServiceInstance.current.getFootnoteNumber(FOOTNOTE_NAME_UVP_SET_PRICE_NOT_EQUAL_TO_INDIVIDUAL_PRICE, EFootnoteNamespace.PDP_ALL_VARIANTS_ARTICLE_PRICE)}
                                </sup>
                                : undefined}

                            {isBatteryDeposit ?
                                <small className="deposit add-price">
                                    <span>
                                        <FormattedCurrency price={variant.battery_deposit_price / PRICE_DIVIDE_NUMBER} currency={variant.currency?.code}/>
                                        &nbsp;{translate('Deposit', {ns: 'article-detail'})}
                                        <sup>
                                            {footnoteServiceInstance.current.getFootnoteNumber(FootnoteManager.deposit, EFootnoteNamespace.PDP_ALL_VARIANTS_ARTICLE_PRICE)}
                                        </sup>
                                    </span>
                                </small>
                                : undefined}
                        </td>
                        <td className="row-small-half row-actions">
                            <span className="hide-for-large row-headline">{translate('Actions', {ns: 'article-detail'})}: </span>
                            <ArticleTabVariantAddToCart
                                productName={variant.name}
                                productSku={variant.sku}
                                productCanBeOrdered={variant.can_be_ordered}
                                productPrice={variant.price}
                                productName2={variantTitle}
                                csrfToken={csrfToken}
                                addToCartApiUrl={addToCartApiUrl}
                                recommendationApiUrl={newRecommendationApiUrl}
                            />
                        </td>
                    </tr>
                );
            })}

        </React.Fragment>
    );
};

// tslint:disable-next-line:max-file-line-count
export default articleTabVariantList;
